<template>
  <div>
    <van-card style="padding-bottom:0px"
      v-for="(item, index) in posts"
      :key="index"
      :title="$helper.ilkharfBuyuk(item.isim).substring(0, 80)"
      :desc="'Toplam Miktar : '+item.adet2 + ' adet'"
      
    >
      <template #tags>

        <van-tag plain 
          style="padding:5px 8px; color:#000; margin-top:10px; font-size:14px"
        >{{ $helper.parabirimi(item.fiyat,item.doviz_cinsi) }}
        </van-tag>
        <van-tag plain type="success" 
          style="padding:5px 8px; color:#000; margin-top:10px; font-size:14px"
        >{{ $helper.parabirimi(item.fiyat* item.adet2,item.doviz_cinsi)  }}
        </van-tag>
        <van-tag plain 
        style="padding:5px 8px; color:black; margin-top:10px; font-size:14px"
        type="danger">{{ item.depo }}</van-tag>



        <van-icon name="delete-o" size="33" style="float: right;margin-left:20px" @click="deletus(index)"/>
        <van-icon name="minus" size="33" style="float: right;margin-left:20px" @click="adetchange(index,'eksilt')"/>
        <van-icon name="plus" style="float: right;" @click="adetchange(index,'arttir')"/>


      </template>
    </van-card>


<van-button 
v-if="$store.getters.getVirtual.proforma[
          this.$store.getters.getCari.aktif.kod
        ].length>0"
to="/sonuc" block style="margin: 10px 0 60px 0" pure type="danger">SİPARİŞ VER</van-button>


</div>
</template>

<script>

export default {
components:{
// headers,detay
},
  data() {
    return {};
  },
  created() {            
    // this.$store.commit("bekle2",false);
  },
    computed: {
      posts() {
        return this.$store.getters.getVirtual.proforma[
          this.$store.getters.getCari.aktif.kod
        ];
      },
    },
    methods: {


          adetchange(index,islem) {
            this.$store.commit("setLoading",[true,'...']);
            let data = {
              islem: islem,
              index: index,
              tarih: this.$helper.getNow().full,
              virtual: 'proforma',
            };
            this.$store.commit("updateVirtual", data);
            setTimeout(() => {
              this.$store.commit("setLoading",[false,'...']);
            }, 500);
          },
          deletus(index) {
            this.$dialog.confirm({
              title: 'Sil işlemi',
              message: 'Onaylıyormusunuz ?',
              confirmButtonText	 : 'Evet',
              cancelButtonText : 'iptal'
            })
            .then(() => {

                let data = {
                  islem: "eksilt", // yazmasanda olur
                  index: index,
                  tarih: this.$helper.getNow().full,
                  virtual: 'proforma',
                };
                this.$store.dispatch("deleteVirtual", data);

                this.$notify({ type: 'success', message: 'İşlem başarılı' });

            })
            .catch(() => {
              this.$notify({ type: 'danger', message: 'İptal Edildi' });

            });
          },
          totalHesapla(){
            return new Promise((resolve, reject) => {
                resolve(this.$helper.groupByleskov(
                this.$store.getters.getVirtual.proforma[
                  this.$store.getters.getCari.aktif.kod
                ].kayit,
              ))
            })
          },

    }
};
</script>
<style scoped>


</style>


// WEBPACK FOOTER //
// src/views/liste.vue